import { render } from "./MobileMenuBars.vue?vue&type=template&id=9a645fca&scoped=true"
import script from "./MobileMenuBars.vue?vue&type=script&lang=js"
export * from "./MobileMenuBars.vue?vue&type=script&lang=js"

import "./MobileMenuBars.vue?vue&type=style&index=0&id=9a645fca&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a645fca"]])

export default __exports__